module.exports = __webpack_public_path__ + "c16bc9a0a1942686541c0d06ff1afc18.svg";